import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { CSSTransitionGroup } from 'react-transition-group';
import { withStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';
import Paper from '@material-ui/core/Paper';
import { gapiChecking } from 'src/services/gapi/actions';
import { setCookie } from 'src/utils';
import GoogleLogo from 'src/icons/google-logo';
import DogfoodAdminLogo from 'src/icons/dogfood-admin-logo';
import styles, { durationEnd } from './styles'
import { AUTH_HEADER, SESSION_TIMEOUT } from '../../init';
import { service as sessionService } from '../../../../services/session';

class Panel extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
    }
  }

  onClick = () => {
      window.client.requestAccessToken()
      return false;
  }

  render() {
    const { gapi, classes } = this.props;
    const error = this.state.error || this.props.error;

    return (
      <div className={classes.panel}>
        <CSSTransitionGroup
          transitionName={classes}
          transitionAppearTimeout={durationEnd}
          transitionAppear
        >
          <Paper classes={{ root: classes.paperRoot }}>
            {(!gapi.loaded || gapi.checking) && <LinearProgress className={classes.progress} />}

            <div className={classes.logo}>
              <DogfoodAdminLogo />
            </div>
            <div className={classes.welcome}>
              Welcome to
            </div>
            <div className={classes.title}>
              DOGFOOD ADMIN
            </div>
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              onClick={this.onClick}
              disabled={!gapi.loaded}
            >
              <GoogleLogo className={classes.buttonLogo} />
              Sign in with Google
            </Button>
          </Paper>
        </CSSTransitionGroup>
        {error && (
          <div className={classes.error}>
            {error}
          </div>
        )}
      </div>
    );
  }
}

Panel.propTypes = {
  error: PropTypes.string,
  gapi: PropTypes.shape({
    loaded: PropTypes.bool,
    checking: PropTypes.bool,
  }).isRequired,
  actions: PropTypes.shape({
    checkSession: PropTypes.func.isRequired,
    gapiChecking: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    panel: PropTypes.string.isRequired,
    paperRoot: PropTypes.string.isRequired,
    progress: PropTypes.string.isRequired,
    logo: PropTypes.string.isRequired,
    welcome: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    buttonLogo: PropTypes.string.isRequired,
    error: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  gapi: state.gapi,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    checkSession: sessionService.getFlow('get').request,
    gapiChecking,
  }, dispatch),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
)(Panel);
